import React from 'react';
import InputContainer from '../InputContainer';
import {
  Autocomplete, Grid, MenuItem, TextField,
} from '@mui/material';
import NumberFormat from 'react-number-format';
import { listOfBanks } from 'utils/consts';
import maskNumber from 'components/Masks/maskNumber';
import maskCPF from 'components/Masks/maskCPF';
import maskCNPJ from 'components/Masks/maskCNPJ';
import { isCpf } from '../../helpers';
import { labelField } from 'utils';

function BankData({ formik }) {
  const {
    values, handleBlur, errors, touched, setFieldValue, setFieldTouched,
  } = formik;

  const cpfSelected = isCpf(values.bank_information?.ownership_nature);

  const helperText = (field) => touched.bank_information?.[field] && errors.bank_information?.[field] && errors.bank_information?.[field];
  const error = (field) => touched.bank_information?.[field] && errors.bank_information?.[field];

  const infoError = (field) => ({
    helperText: helperText(field),
    error: error(field),
  });

  return (
    <InputContainer title="Dados Bancários">
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <Autocomplete
          disableClearable
          disablePortal
          id="bank_information.bank_name"
          name="bank_information.bank_name"
          fullWidth
          value={values.bank_information?.bank_name}
          options={listOfBanks}
          noOptionsText="sem opções"
          renderInput={(params) => (
            <TextField
              {...params}
              {...infoError('bank_name')}
              label={labelField('Banco')}
            />
          )}
          onChange={(_, newValue) => setFieldValue('bank_information.bank_name', newValue)}
          onBlur={() => setFieldTouched('bank_information.bank_name', true)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          fullWidth
          InputLabelProps={{
            style: { pointerEvents: 'auto', shrink: true },
          }}
          id="bank_information.account_type"
          select
          label={labelField('Tipo de Conta')}
          onChange={(e) => {
            setFieldValue('bank_information.account_type', e.target.value);
          }}
          onBlur={handleBlur}
          variant="outlined"
          value={values.bank_information?.account_type}
          name="bank_information.account_type"
          {...infoError('account_type')}
        >
          <MenuItem key={1} value="Conta Corrente">
            Conta Corrente
          </MenuItem>
          <MenuItem key={2} value="Conta Poupança">
            Conta Poupança
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          fullWidth
          InputProps={{
            inputComponent: maskNumber,
          }}
          variant="outlined"
          InputLabelProps={{
            style: { pointerEvents: 'auto' },
          }}
          id="bank_information.agency"
          label={labelField('Agência')}
          name="bank_information.agency"
          value={values.bank_information?.agency}
          onChange={(event) => {
            setFieldValue('bank_information.agency', event.target.value.trim());
          }}
          onBlur={handleBlur}
          {...infoError('agency')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          fullWidth
          InputProps={{
            inputComponent: maskNumber,
          }}
          variant="outlined"
          InputLabelProps={{
            style: { pointerEvents: 'auto' },
          }}
          id="bank_information.account_number"
          label={labelField('Conta')}
          name="bank_information.account_number"
          value={values.bank_information?.account_number}
          onChange={(event) => {
            setFieldValue('bank_information.account_number', event.target.value);
          }}
          onBlur={handleBlur}
          {...infoError('account_number')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <NumberFormat
          inputProps={{ maxLength: 1 }}
          fullWidth
          InputLabelProps={{
            style: { pointerEvents: 'auto' },
          }}
          id="bank_information.account_digit"
          label={labelField('Dígito da conta')}
          variant="outlined"
          name="bank_information.account_digit"
          value={values.bank_information?.account_digit}
          onValueChange={(value) => setFieldValue('bank_information.account_digit', value.floatValue)}
          onBlur={handleBlur}
          customInput={TextField}
          {...infoError('account_digit')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <NumberFormat
          inputProps={{ maxLength: 1 }}
          fullWidth
          InputLabelProps={{
            style: { pointerEvents: 'auto' },
          }}
          id="bank_information.operation"
          label={labelField('Operação')}
          variant="outlined"
          name="bank_information.operation"
          value={values.bank_information?.operation}
          onValueChange={(value) => setFieldValue('bank_information.operation', value.floatValue)}
          onBlur={handleBlur}
          customInput={TextField}
          {...infoError('operation')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={4}>
        <TextField
          inputProps={{ maxLength: 100 }}
          fullWidth
          id="bank_information.ownership"
          name="bank_information.ownership"
          value={values.bank_information?.ownership}
          label={labelField('Titularidade')}
          variant="outlined"
          onBlur={handleBlur}
          {...infoError('ownership')}
          onChange={(event) => {
            setFieldValue('bank_information.ownership', event.target.value);
          }}
          color="primary"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          fullWidth
          InputLabelProps={{
            style: { pointerEvents: 'auto', shrink: true },
          }}
          id="bank_information.ownership_nature"
          select
          label={labelField('Natureza do titular')}
          onChange={(e) => {
            setFieldValue('bank_information.ownership_nature', e.target.value);
            setFieldValue('bank_information.ownership_document', '');
          }}
          onBlur={handleBlur}
          variant="outlined"
          value={values.bank_information?.ownership_nature}
          name="bank_information.ownership_nature"
          {...infoError('ownership_nature')}
        >
          <MenuItem key={1} value="Pessoa Física">
            Pessoa Física
          </MenuItem>
          <MenuItem key={2} value="Pessoa Jurídica">
            Pessoa Jurídica
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <TextField
          fullWidth
          InputProps={{
            inputComponent: cpfSelected ? maskCPF : maskCNPJ,
          }}
          variant="outlined"
          id="bank_information.ownership_document"
          label={labelField('Documento do titular')}
          errorAndHelper="ownership_document"
          value={values.bank_information?.ownership_document}
          onChange={(event) => {
            setFieldValue('bank_information.ownership_document', event.target.value);
          }}
          onBlur={handleBlur}
          {...infoError('ownership_document')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={4}>
        <TextField
          inputProps={{ maxLength: 100 }}
          fullWidth
          id="bank_information.observation"
          name="bank_information.observation"
          value={values.bank_information?.observation}
          label="Observações (Opcional)"
          variant="outlined"
          onBlur={handleBlur}
          {...infoError('observation')}
          onChange={(event) => {
            setFieldValue('bank_information.observation', event.target.value);
          }}
          color="primary"
        />
      </Grid>
    </InputContainer>
  );
}

export default BankData;
